import React, { useState } from "react";
import SearchAccountNumber from "../../components/searchAccount/SearchAccount";
import VerifyOtp from "../../components/verifyOtp/VerifyOtp";
import { handlePostRequest } from "../../services/PostTemplate";
import BlockUnblockForm from "./BlockUnblockForm";
import AccountInfo from "../../components/accountInfo/AccountInfo";
import BlockUnblockVerifyOtp from "./BlockUnblockVerifyOtp";

function BlockUnblockAccount() {

    const [step, setStep] = useState("SEARCH");
    const [formData, setFormData] = useState(null);
    const [accountInfoData, setAccountInfoData] = useState(null);

    const handleReturnData = (data, formData) => {
        setAccountInfoData(data?.data);
        setFormData(formData);
        if (data?.data === undefined) {
            setStep("SEARCH");
        }
        else {
            setStep("VERIFY_OTP");
        }
    };

    const onBlockOrUnblock = async (otp, action) => {
        const data = {
            AccountStatus: action,
            ...formData,
            OTP: otp,
        };
        try {
            await handlePostRequest(data, "zbizgateway/accountMaintainence/accountBlockUnblock");
            setStep("SEARCH");
        } catch (error) {
            console.log(error);
        }
    };

    switch (step) {
        case "SEARCH":
            return <SearchAccountNumber title={"Block/Unblock Account"} handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountBlockUnblockInquiry" />;
        case "VERIFY_OTP":
            return (
                <>
                    <SearchAccountNumber title={"Block/Unblock Account"} handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountBlockUnblockInquiry" />
                    <AccountInfo accountInfoData={accountInfoData} />
                    <BlockUnblockVerifyOtp accountInfoData={accountInfoData} onBlockOrUnblock={onBlockOrUnblock} />
                </>
            );
        // case "ACTION":
        //     return (
        //         <>
        //             <SearchAccountNumber title={"Block/Unblock Account"} handleReturnData={handleReturnData} api="zbizgateway/accountMaintainence/accountBlockUnblockInquiry" />
        //             <AccountInfo accountInfoData={accountInfoData} />
        //             <VerifyOtp onVerifyOtp={onVerifyOtp} emailOtp={"mobileOtp"} />
        //             <BlockUnblockForm accountInfoData={accountInfoData} onBlockOrUnblock={onBlockOrUnblock} />
        //         </>
        //     );
        default:
            return null;
    }
}

export default BlockUnblockAccount;
